import React from 'react';
import { Form, Switch } from 'antd';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import FundkyModal from 'Parts/ui/components/FundkyModal';
import FakeField from 'Parts/ui/components/fields/FakeField';
import FundkyTooltip from 'Parts/ui/components/FundkyTooltip';
import { getPlugin } from '../../../../pluginActions';

import eventAdminConfigurationInformationForm_en from './locales/EventAdminConfigurationInformationForm_en.json';
import eventAdminConfigurationInformationForm_fr from './locales/EventAdminConfigurationInformationForm_fr.json';

class EventAdminConfigurationInformationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayThirdPartyActionModal: false,
      displayDonationReceiptsActionModal: false,
      switchThirdPartyActivated: true,
      switchDonationReceiptsActivated: false,
      plugins: {
        TaxReceipt: null
      }
    };

    i18next.addResourceBundle(
      'en',
      'EventAdminConfigurationInformationForm',
      eventAdminConfigurationInformationForm_en
    );
    i18next.addResourceBundle(
      'fr',
      'EventAdminConfigurationInformationForm',
      eventAdminConfigurationInformationForm_fr
    );
  }

  componentDidMount() {
    getPlugin(this.props.platform, 'TaxReceipt').then(TaxReceipt => {
      this.setState({
        plugins: { TaxReceipt: TaxReceipt }
      });
    });
  }

  handleActivation = (value, caller) => {
    if (value) {
      this.setState({
        [`display${caller}ActionModal`]: true
      });
    } else {
      // TODO plug api
      // if (caller === 'ThirdParty') {
      //   // api req to save
      // } else {
      //   // api req to save
      // }
      this.setState({
        [`switch${caller}Activated`]: false
      });
    }
  };

  handleModalAccept = caller => {
    // TODO plug api
    // if (caller === 'ThirdParty') {
    //   // api req to save
    // } else {
    //   // api req to save
    // }
    this.setState(prevState => ({
      [`display${caller}ActionModal`]: false,
      [`switch${caller}Activated`]: !prevState[`switch${caller}Activated`]
    }));
  };

  handleModalCancel = caller => {
    this.setState({
      [`display${caller}ActionModal`]: false
    });
  };

  render() {
    const { t, form } = this.props;
    const { displayThirdPartyActionModal, displayDonationReceiptsActionModal } = this.state;

    const activationThirdPartyModal = (
      <FundkyModal
        displayModal={displayThirdPartyActionModal}
        acceptAction={() => this.handleModalAccept('ThirdParty')}
        cancelAction={() => this.handleModalCancel('ThirdParty')}
      >
        <p>{t('third-party-modal-content')}</p>
      </FundkyModal>
    );

    const activationDonationReceiptsModal = (
      <FundkyModal
        displayModal={displayDonationReceiptsActionModal}
        acceptAction={() => this.handleModalAccept('DonationReceipts')}
        cancelAction={() => this.handleModalCancel('DonationReceipts')}
      >
        <p>{t('donation-receipts-modal-content')}</p>
      </FundkyModal>
    );

    const statusTooltip = (
      <p>
        {t('status-tooltip')}{' '}
        <a href={`${t('status-tooltip-link')}`} target="_blank">
          {t('status-tooltip-link')}
        </a>
      </p>
    );

    return (
      <>
        {activationThirdPartyModal}
        {activationDonationReceiptsModal}
        <Form className="EventAdminConfigurationInformationForm">
          <FakeField
            label={t('status-label')}
            data={
              //TODO Plug status to SAPI when ready
              <span>
                {t('status-active')} <FundkyTooltip title={statusTooltip} />
              </span>
            }
          />
          <h3>{t('third-party-h3')}</h3>
          <p>{t('third-party-notice2')}</p>
          {/* <FakeField
            label={t('third-party-label')}
            data={
              <Switch
                checked={this.state.switchThirdPartyActivated}
                checkedChildren={t('yes')}
                unCheckedChildren={t('no')}
                onClick={e => this.handleActivation(e, 'ThirdParty')}
              />
            }
            notice={t('third-party-notice')}
          /> */}

          {this.state.plugins.TaxReceipt && (
            <>
              <h3>{t('donation-receipts-h3')}</h3>
              <p>{t('donation-receipts-message')}</p>
              {/* <FakeField
                label={t('donation-receipts-label')}
                data={
                  <Switch
                    checked={this.state.switchDonationReceiptsActivated}
                    checkedChildren={t('yes')}
                    unCheckedChildren={t('no')}
                    onClick={e => this.handleActivation(e, 'DonationReceipts')}
                  />
                }
              /> */}
            </>
          )}
        </Form>
      </>
    );
  }
}

export default translate('EventAdminConfigurationInformationForm')(
  EventAdminConfigurationInformationForm
);
